<nz-card nzTitle="Item log">
  <nz-skeleton [nzActive]="true" [nzLoading]="(isLoading$ | async) ?? false">
    <em-item-logs-table
      [data]="(itemLogs$ | async) ?? []"
      [errorMsg]="(error$ | async) ?? undefined"
    ></em-item-logs-table>
  </nz-skeleton>
</nz-card>
